import { IHeadersDataPagination } from "interfaces/pagination";

export const defaultPaginationHeaders: IHeadersDataPagination = {
  paginationcurrent: 1,
  paginationlimit: 100000,
};
